import { render, staticRenderFns } from "./CreateAddonDomainForm.vue?vue&type=template&id=e70b5600&"
import script from "./CreateAddonDomainForm.vue?vue&type=script&lang=js&"
export * from "./CreateAddonDomainForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e70b5600')) {
      api.createRecord('e70b5600', component.options)
    } else {
      api.reload('e70b5600', component.options)
    }
    module.hot.accept("./CreateAddonDomainForm.vue?vue&type=template&id=e70b5600&", function () {
      api.rerender('e70b5600', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Domains/AddonDomains/CreateAddonDomainForm.vue"
export default component.exports